import { render, staticRenderFns } from "./AbSaleCell.vue?vue&type=template&id=20813dfd&scoped=true"
import script from "./AbSaleCell.vue?vue&type=script&lang=js"
export * from "./AbSaleCell.vue?vue&type=script&lang=js"
import style0 from "./AbSaleCell.vue?vue&type=style&index=0&id=20813dfd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20813dfd",
  null
  
)

export default component.exports